import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

import { useContext, useEffect, useRef, useState } from "react";
import InputField from "../../CommonComponents/InputField";
import SelectInputField from "../../CommonComponents/SelectInputField";
import AddIcon from "@mui/icons-material/Add";
import CustomCancelButton from "../../CommonComponents/CustomCancelButton";
import { ThemeContext } from "../../Homepage";
import {
  defaultNodeData,
  defaultSubOrgeData,
  defaultProjectData,
  errorOrgObj,
  errorProjObj,
  URL_REGEX,
  LAT_LAN_REGEX,
  PIN_REGEX,
  validateNodeData,
  errorSubOrgObj,
} from "./Utils";
 const NodeActionDialog = ({
  open,
  actionType,
  node,
  onClose,
  onSave,
  onDeleteConfirm,
  selectedTreeNode,
}) => {

  const { theme } = useContext(ThemeContext);
  const [imageheight, setImageheight] = useState(100);
  const [backgroundimg, setBackgroundimg] = useState("");
  const [imagewidth, setImagewidth] = useState(100);
  const inputFile = useRef(null);
  const [nodeData, setNodeData] = useState(defaultNodeData);
  const [errors, setErrors] = useState({});
  const [showmsg, setShowmsg] = useState(false);
  const [selectedNodeType, setSelectedNodeType] = useState("Organization");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (node && actionType !== "add") {
      setNodeData(node);
    } else if (actionType == "add") {
      setNodeData(defaultNodeData);
    }
    inputFile.current = null;
    setBackgroundimg("");
  }, [node, actionType]);

  useEffect(() => {
    if (selectedTreeNode.id == "root") {
      setSelectedNodeType("Organization");
      setOptions([{ label: "Organization", value: "Organization" }]);
    } else {
      setSelectedNodeType("Sub-organization");
      setOptions([
        { label: "Sub-organization", value: "Sub-organization" },
        { label: "Project", value: "Project" },
      ]);
    }
  }, [selectedTreeNode]);

  useEffect(() => {
    if (selectedNodeType?.toLowerCase() === "project") {
      setNodeData(defaultProjectData);
      setErrors(errorProjObj);
    }
    if (selectedNodeType?.toLowerCase() === "organization") {
      setNodeData(defaultNodeData);
      setErrors(errorOrgObj);
    }
    if (selectedNodeType?.toLowerCase() === "sub-organization") {
      setNodeData(defaultSubOrgeData);
      setErrors(errorSubOrgObj);
    }
  }, [selectedNodeType]);

  const handleSave = () => {
    if (validateNodeData(nodeData, errors, setErrors))
       return;
    onSave(nodeData);
    if(selectedTreeNode.id == "root"){
      setSelectedNodeType("organization");
    }else{
      setSelectedNodeType("sub-organization");
    }
    onClose();
  };

  const handleChange = (field, value) => {
    setNodeData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleNestedChange = (field, subField, value) => {
    setNodeData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        [subField]: value,
      },
    }));

    if (errors[subField]) {
      setErrors((prev) => ({ ...prev, [subField]: "" }));
    }
  };

  const handleDelete = () => {
    onDeleteConfirm(node?.id);
    onClose();
  };

  const getNestedValue = (obj, path) => {
    return path
      .split(".")
      .reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : ""),
        obj
      );
  };

  // const inputFields = [
  //   { label: "Organization Name", field: "Organizationname", nested: false,required: true },
  //   { label: "Description", field: "Description", nested: false,required: false },
  //   { label: "Organization Link", field: "Organizationlink", nested: false,required: false },
  //   { label: "Country", field: "Country", nested: true, parent: "Organizationdetails",required: true },
  //   { label: "State", field: "State", nested: true, parent: "Organizationdetails",required: true },
  //   { label: "Location", field: "Location", nested: true, parent: "Organizationdetails",required: true },
  //   { label: "Latitude", field: "Latitude", nested: true, parent: "Organizationdetails",required: false },
  //   { label: "Longitude", field: "Longitude", nested: true, parent: "Organizationdetails",required: false },
  //   { label: "PIN Code", field: "Pin", nested: true, parent: "Organizationdetails",required: true },
  // ];

  // const renderInputFields = () => {
  //   return inputFields.map(({ label, field, nested, parent,required }) => (
  //     <InputField
  //       key={field}
  //       label={label}
  //       required={required}
  //       value={nested ? nodeData?.[parent]?.[field] : nodeData?.[field]}
  //       onChange={(e) =>
  //         nested
  //           ? handleNestedChange(parent, field, e.target.value)
  //           : handleChange(field, e.target.value)
  //       }
  //       error={!!errors[field]}
  //       helperText={errors[field]}
  //       style={{
  //         width: "100%",
  //         color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
  //       }}
  //       inputProps={{ readOnly: actionType === "view" }}
  //     />
  //   ));
  // };

  const inputFields = [
    { label: "Organization Name", field: "Organizationname", nested: false, required: true },
    { label: "Description", field: "Description", nested: false, required: false },
    { label: "Organization Link", field: "Organizationlink", nested: false, required: false },
    { label: "Country", field: "Country", nested: true, parent: "Organizationdetails", required: true },
    { label: "State", field: "State", nested: true, parent: "Organizationdetails", required: true },
    { label: "Location", field: "Location", nested: true, parent: "Organizationdetails", required: true },
    { label: "Latitude", field: "Latitude", nested: true, parent: "Organizationdetails", required: false },
    { label: "Longitude", field: "Longitude", nested: true, parent: "Organizationdetails", required: false },
    {
      label: "PIN Code",
      field: "Pin",
      nested: true,
      parent: "Organizationdetails",
      required: true,
      inputType: "number", 
    },
  ];
  
  const renderInputFields = () => {
    return inputFields.map(({ label, field, nested, parent, required, inputType }) => (
      <InputField
        key={field}
        label={label}
        required={required}
        value={nested ? nodeData?.[parent]?.[field] : nodeData?.[field]}
        onChange={(e) =>
          nested
            ? handleNestedChange(parent, field, e.target.value)
            : handleChange(field, e.target.value)
        }
        error={!!errors[field]}
        helperText={errors[field]}
        FormHelperTextProps={{
          sx: {
            maxWidth: "500px",
          },
        }}
        style={{
          width: "100%",
          color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
        }}
        inputProps={{
          readOnly: actionType === "view",
          ...(inputType === "number" && { inputMode: "numeric", pattern: "[0-9]*" }), // Restrict to numbers
        }}
      />
    ));
  };

  const getOrganizationDetails = () => {
    return (
      <>
        {renderInputFields()}
        {renderLogoSection()}
      </>
    );
  };


  // const getProjectDetails = () => {
  //   return (
  //     <>

  //       <InputField
  //         label={"Project Name"}
  //         required={true}
  //         value={nodeData.Projectname}
  //         onChange={(e) => handleChange("Projectname", e.target.value)}
  //         error={!!errors.Projectname}
  //         helperText={errors.Projectname}
  //         style={{ width: "100%" }}
  //       />

  //       {actionType && (
  //         <InputField
  //           label={"Description"}
  //           required={true}
  //           value={nodeData.Description}
  //           onChange={(e) => handleChange("Description", e.target.value)}
  //           sx={{ marginBottom: 2, marginTop: 2 }}
  //           error={!!errors.Description}
  //           helperText={errors.Description}
  //           style={{ width: "100%" }}
  //           inputProps={{ readOnly: actionType === "view" }}
  //         />
  //       )}

  //       <InputField
  //         label={"Country"}
  //         required={true}
  //         value={nodeData?.Projectdetails?.Country}
  //         onChange={(e) =>
  //           handleNestedChange("Projectdetails", "Country", e.target.value)
  //         }
  //         sx={{ marginBottom: 2, marginTop: 2 }}
  //         error={!!errors.Country}
  //         helperText={errors.Country}
  //         style={{ width: "100%" }}
  //         inputProps={{ readOnly: actionType === "view" }}
  //       />

  //       <InputField
  //         label={"State"}
  //         required={true}
  //         value={nodeData?.Projectdetails?.State}
  //         onChange={(e) =>
  //           handleNestedChange("Projectdetails", "State", e.target.value)
  //         }
  //         sx={{ marginBottom: 2, marginTop: 2 }}
  //         error={!!errors.State}
  //         helperText={errors.State}
  //         style={{ width: "100%" }}
  //         inputProps={{ readOnly: actionType === "view" }}
  //       />

  //       <InputField
  //         label={"Location"}
  //         required={true}
  //         value={nodeData?.Projectdetails?.Location}
  //         onChange={(e) =>
  //           handleNestedChange("Projectdetails", "Location", e.target.value)
  //         }
  //         sx={{ marginBottom: 2, marginTop: 2 }}
  //         error={!!errors.Location}
  //         helperText={errors.Location}
  //         style={{ width: "100%" }}
  //         inputProps={{ readOnly: actionType === "view" }}
  //       />

  //       <InputField
  //         label={"Longitude"}
  //         required={true}
  //         value={nodeData?.Projectdetails?.Longitude}
  //         onChange={(e) =>
  //           handleNestedChange("Projectdetails", "Longitude", e.target.value)
  //         }
  //         sx={{ marginBottom: 2, marginTop: 2 }}
  //         error={!!errors.Longitude}
  //         helperText={errors.Longitude}
  //         style={{ width: "100%" }}
  //         inputProps={{ readOnly: actionType === "view" }}
  //       />
  //       <InputField
  //         label={"Latitude"}
  //         required={true}
  //         value={nodeData?.Projectdetails?.Latitude}
  //         onChange={(e) =>
  //           handleNestedChange("Projectdetails", "Latitude", e.target.value)
  //         }
  //         sx={{ marginBottom: 2, marginTop: 2 }}
  //         error={!!errors.Latitude}
  //         helperText={errors.Latitude}
  //         style={{ width: "100%" }}
  //         inputProps={{ readOnly: actionType === "view" }}
  //       />

  //       <InputField
  //         label={"Pin"}
  //         required={true}
  //         value={nodeData?.Projectdetails?.Pin}
  //         onChange={(e) =>
  //           handleNestedChange("Projectdetails", "Pin", e.target.value)
  //         }
  //         sx={{ marginBottom: 2, marginTop: 2 }}
  //         error={!!errors.Pin}
  //         helperText={errors.Pin}
  //         style={{ width: "100%" }}
  //         inputProps={{ maxLength: 6, readOnly: actionType === "view" }}
  //       />
  //           <div
  //         style={{
  //           display: "flex",
  //           alignItems: "flex-start",
  //           flexDirection: "column",
  //         }}
  //       >
  //         <Typography
  //           style={{
  //             marginBottom: "10px",
  //             color: "var(--PrimaryText)",
  //             marginTop: "10px",
  //             fontSize: "18px",
  //             fontWeight: 400,
  //             color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
  //           }}
  //         >
  //           Add Logo
  //         </Typography>
  //         <div style={{ display: "flex", gap: "50px", alignItems: "center" }}>
  //           <div
  //             style={{
  //               height: "100px",
  //               width: "100px",
  //               border: "2px solid",
  //               borderColor: "var(--LK_BrandBlue_1)",
  //               borderRadius: "50%",
  //               display: "flex",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               backgroundImage: `url(${backgroundimg})`,
  //               backgroundRepeat: "no-repeat",
  //               backgroundPosition: "center center",
  //               backgroundSize: `${imagewidth}px ${imageheight}px`,
  //             }}
  //           >
  //             <input
  //               style={{ display: "none" }}
  //               ref={inputFile}
  //               onChange={handleImageUpload}
  //               type="file"
  //               accept=".png,.PNG"
  //               multiple={false}
  //             />
  //             <AddIcon
  //               style={{
  //                 width: "40px",
  //                 height: "40px",
  //                 color: backgroundimg === "" ? "var(--LK_BrandBlue_1)" : "transparent",
  //                 cursor: "pointer",
  //               }}
  //               onClick={handleaddlogoclick}
  //             />
  //           </div>
  //           <div>
  //             <div style={{ display: "flex", flexDirection: "column" }}>
  //               {/* <TextField
  //                 id="Height"
  //                 label={
  //                   <Typography
  //                     style={{
  //                       fontSize: 20,
  //                       fontWeight: 500,
  //                       color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
  //                     }}
  //                   >
  //                     Height
  //                   </Typography>
  //                 }
  //                 variant="standard"
  //                 InputProps={{
  //                   startAdornment: <InputAdornment position="start"></InputAdornment>,
  //                   style: {
  //                     color: "var(--PrimaryText)",
  //                   },
  //                 }}
  //                 sx={{
  //                   width: "80px",
  //                   marginBottom: "10px",
  //                   "& .MuiInput-underline:before": {
  //                     borderBottomColor: "var(--PrimaryText)",
  //                   },
  //                 }}
  //                 value={nodeData?.Logo?.height}
  //                 onChange={(e) => handleNestedChange("Logo", "height", e.target.value)}
  //                 helperText={errors.LogoHeight}
  //               />
  //               <TextField
  //                 id="Width"
  //                 label={
  //                   <Typography
  //                     style={{
  //                       fontSize: 20,
  //                       fontWeight: 500,
  //                       color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
  //                     }}
  //                   >
  //                     Width
  //                   </Typography>
  //                 }
  //                 variant="standard"
  //                 InputProps={{
  //                   startAdornment: <InputAdornment position="start"></InputAdornment>,
  //                   style: {
  //                     color: "var(--PrimaryText)",
  //                   },
  //                 }}
  //                 sx={{
  //                   width: "80px",
  //                   marginBottom: "20px",
  //                   "& .MuiInput-underline:before": {
  //                     borderBottomColor: "var(--PrimaryText)",
  //                   },
  //                 }}
  //                 value={nodeData?.Logo?.width}
  //                 onChange={(e) => handleNestedChange("Logo", "width", e.target.value)}
  //                 helperText={errors.LogoWidth}
  //               /> */}
  //               <TextField
  //                   id="Height"
  //                   label={
  //                     <Typography
  //                       style={{
  //                         fontSize: 20,
  //                         fontWeight: 500,
  //                         color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
  //                       }}
  //                     >
  //                       Height
  //                     </Typography>
  //                   }
  //                   variant="standard"
  //                   InputProps={{
  //                     startAdornment: <InputAdornment position="start"></InputAdornment>,
  //                     style: {
  //                       color: "var(--PrimaryText)",
  //                     },
  //                   }}
  //                   sx={{
  //                     width: "80px",
  //                     marginBottom: "10px",
  //                     "& .MuiInput-underline:before": {
  //                       borderBottomColor: "var(--PrimaryText)",
  //                     },
  //                   }}
  //                   value={nodeData?.Logo?.height}
  //                   onChange={(e) => handleNestedChange("Logo", "height", e.target.value)}
  //                   error={!!errors.LogoHeight} // Display error state
  //                   helperText={errors.LogoHeight} // Display error message
  //                 />

  //                 <TextField
  //                   id="Width"
  //                   label={
  //                     <Typography
  //                       style={{
  //                         fontSize: 20,
  //                         fontWeight: 500,
  //                         color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
  //                       }}
  //                     >
  //                       Width
  //                     </Typography>
  //                   }
  //                   variant="standard"
  //                   InputProps={{
  //                     startAdornment: <InputAdornment position="start"></InputAdornment>,
  //                     style: {
  //                       color: "var(--PrimaryText)",
  //                     },
  //                   }}
  //                   sx={{
  //                     width: "80px",
  //                     marginBottom: "20px",
  //                     "& .MuiInput-underline:before": {
  //                       borderBottomColor: "var(--PrimaryText)",
  //                     },
  //                   }}
  //                   value={nodeData?.Logo?.width}
  //                   onChange={(e) => handleNestedChange("Logo", "width", e.target.value)}
  //                   error={!!errors.LogoWidth} // Display error state
  //                   helperText={errors.LogoWidth} // Display error message
  //                 />
  //             </div>
  //           </div>
  //         </div>
  //         <Typography
  //                 style={{
  //                   fontSize: "12px",
  //                   color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
  //                   marginTop: "5px",
  //                 }}
  //               >
  //                 Allowed formats: PNG, JPG, JPEG, GIF
  //               </Typography>
  //       </div>
  //     </>
  //   );
  // };

  const projectInputFields = [
    { label: "Project Name", field: "Projectname", nested: false, required: true },
    { label: "Description", field: "Description", nested: false, required: false },
    { label: "Country", field: "Country", nested: true, parent: "Projectdetails", required: true },
    { label: "State", field: "State", nested: true, parent: "Projectdetails", required: true },
    { label: "Location", field: "Location", nested: true, parent: "Projectdetails", required: true },
    { label: "Longitude", field: "Longitude", nested: true, parent: "Projectdetails", required: true },
    { label: "Latitude", field: "Latitude", nested: true, parent: "Projectdetails", required: true },
    {
      label: "Pin",
      field: "Pin",
      nested: true,
      parent: "Projectdetails",
      required: true,
      inputType: "number", // Restrict to numbers
    },
  ];
  
  const renderProjectInputFields = () => {
    return projectInputFields.map(({ label, field, nested, parent, required, inputType }) => (
      <InputField
        key={field}
        label={label}
        required={required}
        value={nested ? nodeData?.[parent]?.[field] : nodeData?.[field]}
        onChange={(e) =>
          nested
            ? handleNestedChange(parent, field, e.target.value)
            : handleChange(field, e.target.value)
        }
        error={!!errors[field]}
        helperText={errors[field]}
        FormHelperTextProps={{
          sx: {
            maxWidth: "500px",
          },
        }}
        style={{
          width: "100%",
          color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
        }}
        inputProps={{
          readOnly: actionType === "view",
          ...(inputType === "number" && { inputMode: "numeric", pattern: "[0-9]*" }), // Restrict to numbers
        }}
      />
    ));
  };
  
  const renderLogoSection = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{
            marginBottom: "10px",
            color: "var(--PrimaryText)",
            marginTop: "10px",
            fontSize: "18px",
            fontWeight: 400,
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
          }}
        >
          Add Logo
        </Typography>
        <div style={{ display: "flex", gap: "50px", alignItems: "center" }}>
          <div
            style={{
              height: "100px",
              width: "100px",
              border: "2px solid",
              borderColor: "var(--LK_BrandBlue_1)",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage: `url(${backgroundimg})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: `${imagewidth}px ${imageheight}px`,
            }}
          >
            <input
              style={{ display: "none" }}
              ref={inputFile}
              onChange={handleImageUpload}
              type="file"
              accept=".png,.PNG,.jpg,.jpeg,.gif"
              multiple={false}
            />
            <AddIcon
              style={{
                width: "40px",
                height: "40px",
                color: backgroundimg === "" ? "var(--LK_BrandBlue_1)" : "transparent",
                cursor: "pointer",
              }}
              onClick={handleaddlogoclick}
            />
          </div>
          <div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <TextField
                id="Height"
                label={
                  <Typography
                    style={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                    }}
                  >
                    Height
                  </Typography>
                }
                variant="standard"
                InputProps={{
                  startAdornment: <InputAdornment position="start"></InputAdornment>,
                  style: {
                    color: "var(--PrimaryText)",
                  },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "10px",
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={nodeData?.Logo?.height}
                onChange={(e) => handleNestedChange("Logo", "height", e.target.value)}
                error={!!errors.LogoHeight} // Display error state
                helperText={errors.LogoHeight} // Display error message
              />
  
              <TextField
                id="Width"
                label={
                  <Typography
                    style={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                    }}
                  >
                    Width
                  </Typography>
                }
                variant="standard"
                InputProps={{
                  startAdornment: <InputAdornment position="start"></InputAdornment>,
                  style: {
                    color: "var(--PrimaryText)",
                  },
                }}
                sx={{
                  width: "80px",
                  marginBottom: "20px",
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "var(--PrimaryText)",
                  },
                }}
                value={nodeData?.Logo?.width}
                onChange={(e) => handleNestedChange("Logo", "width", e.target.value)}
                error={!!errors.LogoWidth} // Display error state
                helperText={errors.LogoWidth} // Display error message
              />
            </div>
          </div>
        </div>
        <Typography
          style={{
            fontSize: "12px",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            marginTop: "5px",
          }}
        >
          Allowed formats: PNG, JPG, JPEG, GIF
        </Typography>
      </div>
    );
  };
  
  const getProjectDetails = () => {
    return (
      <>
        {renderProjectInputFields()}
        {renderLogoSection()}
      </>
    );
  };
  const base64convert = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.error("Error reading file:", error);
    };
  };
  
  const handleImageUpload = (e) => {
    const { files } = e.target;
  
    if (files && files.length) {
      const file = files[0];
      const filename = file.name;
      const parts = filename.split(".");
      const fileType = parts[parts.length - 1];
  
      // Validate file type
      if (!["png", "jpg", "jpeg", "gif"].includes(fileType.toLowerCase())) {
        alert("Invalid file type. Please upload an image file (PNG, JPG, JPEG, GIF).");
        return;
      }
  
      base64convert(file, (result) => {
        setBackgroundimg(result); // Update the background image
        setNodeData((prev) => ({
          ...prev,
          Logo: {
            ...prev.Logo,
            base64: result,
          },
        }));
      });
    }
  };

  const handleaddlogoclick = () => {
    if (inputFile && inputFile.current) {
      inputFile.current.value = "";
      inputFile.current.click();
    }
  };

  const handleResetLogo = (type) => {
    setBackgroundimg("");
    handleNestedChange(type, "Logo", "");
  };

  useEffect(() => {
    if (node && actionType !== "add") {
      setNodeData(node);
      setBackgroundimg(node?.Logo?.base64 || ""); // Set background image if it exists
    } else if (actionType === "add") {
      setNodeData(defaultNodeData);
      setBackgroundimg(""); // Clear background image for new entries
    }
    inputFile.current = null;
    setErrors({});
  }, [node, actionType,open]);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "auto",
      border: "1.5px solid #008cd7",
      // gap: "4px",
      marginTop: 0,
      backgroundColor: "#FFFFFF",
      color: "#3C3C3C",
      // borderRadius: "0px 0px 0px 0px",
    },
    divider: {
      // borderStyle: "solid",
      // borderRightWidth: "20px",
      // borderColor: "#3C3C3C",
      // borderWidth: "thin",
      // margin: "8px 8px",
      // maxHeight: "100px",
      borderWidth: "thin",
      // borderColor: "#3C3C3C",
      height: "80%",
      margin:"auto 0px",
    },
    cardText: {
      marginBottom: 0,
      padding: "4px 0px",
    },
    typographyLabel: {
      fontSize: 14,
      fontWeight: 400,
      marginTop: -2,
    },
    typographyValue: {
      fontSize: 14,
      fontWeight: 400,
    },
  };
  const details = [
    { label: 'Name', value: node?.Organizationname || node?.Projectname },
    { label: 'Type', value: node?.Type },
    { label: 'Location', value: node?.Organizationdetails?.Location || node?.Projectdetails?.Location || 'N/A' },
    { label: 'Latitude', value: node?.Organizationdetails?.Latitude || node?.Projectdetails?.Latitude || 'N/A' },
    { label: 'Longitude', value: node?.Organizationdetails?.Longitude || node?.Projectdetails?.Longitude || 'N/A' },
    { label: 'Country', value: node?.Organizationdetails?.Country || node?.Projectdetails?.Country || 'NA' },
    { label: 'State', value: node?.Organizationdetails?.State || node?.Projectdetails?.State || 'NA' },
    { label: 'Pin', value: node?.Organizationdetails?.Pin || node?.Projectdetails?.Pin || 'NA' },
  ];

  const CardText = ({ label, value }) => (
    <Box className="cardtext">
      <Typography sx={{ fontSize: 14, fontWeight: 400 }}>{label}</Typography>
      <Typography sx={{ fontSize: 15, fontWeight: 400,fontStyle:'bold' }}>{value}</Typography>
    </Box>
  );
  const organizations = node?.children?.filter(
    (item) => item.Type === "organization"
  );
  const projects = node?.children?.filter((item) => item.Type === "project");

  const createTable = (dataArray, tableId) => {
    if (!dataArray || dataArray.length === 0) return null;

    const isOrgTable = tableId === "org";
    const headerLabel = isOrgTable ? "Organizations" : "Projects";
    const dataKey = isOrgTable ? "Organizationname" : "Projectname";
    const tableStyles = {
      table: {
       marginTop: '20px',
        borderCollapse: 'collapse',
        marginBottom: '20px',
        width:'150px'
      },
      th: {
        border: '1.5px solid #008cd7',
        padding: '8px',
        textAlign: 'left',
        backgroundColor: '#f2f2f2',
      },
      td: {
        border: '1.5px solid #008cd7',
        padding: '8px',
      },
    };

    return (
       <table id={tableId} style={tableStyles.table}>
      <thead>
        <tr>
          <th style={tableStyles.th}>{headerLabel}</th>
        </tr>
      </thead>
      <tbody>
        {dataArray.map((item, index) => (
          <tr key={index}>
            <td style={tableStyles.td}>{item?.[dataKey]}</td>
          </tr>
        ))}
      </tbody>
    </table>
    );
  };
  const getActionText = (actionType, node) => {
    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
    const nodeType = node?.Type ? capitalize(node.Type) : '';
  
    switch (actionType) {
      case 'add':
      return selectedTreeNode.id === 'root'
        ? 'Create Organization'
        : 'Create Sub-Organization/Project';
      case 'edit':
        return `Edit ${nodeType} Details`;
      case 'view':
        return `View ${nodeType} Details`;
      case 'delete':
        return `Delete ${nodeType} Details`;
      default:
        return '';
    }
  };
  
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            boxShadow: "none",
            overflowY: "scroll",
            scrollbarWidth: "thin",
            minWidth: "600px",
            maxWidth: actionType === "view" ? "800px" : "600px",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            margin: "8px 0px",
            fontWeight: "400",
            padding: "0px 16px",
            height: "28px",
            color: "#7E7E7E",
            fontWeight: "700",
            fontSize: "24px",
          }}
        >
          
             {getActionText(actionType, node)}
        </DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            margin: "8px 0px",
            fontWeight: "400",
            overflow: "unset",
            padding: "24px",
            scrollbarWidth: "thin",
          }}
        >
          {actionType === "view" && node && (
            <Box>
             <Box sx={styles.container}>
              {details.map((detail, index) => (
                <span key={index} style={{ display: "flex",height:"125px" }}>
                  <CardText label={detail.label} value={detail.value} />
                  {index < details.length - 1 && (
                    <Divider orientation="vertical" flexItem sx={styles.divider} />
                  )}
                </span>
              ))}
            </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                { organizations && organizations?.length > 0 && (<>{createTable(organizations, "org")}</>)}
                {projects?.length > 0 && <>{createTable(projects, "proj")}</>}
              </Box>
            </Box>
          )}

          {(actionType === "add" || actionType === "edit") && (
            <Box
              style={{
                backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
                color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                //  display: "flex",
                // justifyContent: "center"
              }}
            >
              {/* {(actionType === "add"  && <Typography>Creating new {selectedNodeType}</Typography>)} */}
              {actionType === "add" && (
                <SelectInputField
                  label={"Type"}
                  value={selectedNodeType}
                  required={true}
                  onChange={(e) => {
                    setSelectedNodeType(e.target.value);
                    setErrors({});
                  }}
                  error={!errors && !selectedNodeType}
                  options={options}
                  variant={"standard"}
                  style={{
                    width: "100%",
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                  }}
                />
              )}
              {/* {JSON.stringify(selectedNodeType)} */}
              {nodeData?.Type?.toLowerCase() === "organization" &&  getOrganizationDetails()}
              {nodeData?.Type?.toLowerCase() === "sub-organization" && getOrganizationDetails()}
              {nodeData?.Type?.toLowerCase() === "project" && getProjectDetails()}
            </Box>
          )}
          {actionType === "delete" && (
            <Typography>
              Are you sure you want to delete the node{" "}
              <strong>
                {node?.Label || node?.Organizationname || node?.Projectname}
              </strong>{" "}
              ? This action cannot be done.
              {node?.children?.length > 0 &&
                `${node.Type} contains child nodes also will be deleted.`}
            </Typography>
          )}
          {!errors && <Typography color="error"></Typography>}
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* <Button onClick={onClose}>Cancel</Button> */}

          {actionType === "delete" && (
            <Button
              onClick={handleDelete}
              sx={{
                width: "137px",
                borderRadius: "20px",
                opacity: "0px",
              }}
              variant="outlined"
              color="error"
            >
              Delete
            </Button>
          )}
          {(actionType === "add" || actionType === "edit") && (
            <button
              onClick={handleSave}
              // variant="contained"
              // sx={{
              //   width: "137px",
              //   borderRadius: "20px",
              //   opacity: "0px",
              //   background: "#005C8E",
              // }}
              style={{
                width: "125px",
                height: "35px",
                fontSize: "18px",
                backgroundColor: "rgb(0, 92, 142)",
                color: "rgb(255, 255, 255)",
                cursor: "pointer",
                border: "none",
                borderRadius: "25px",
              }}
            >
              {actionType === "add" ? "Create" : "Save"}
            </button>
          )}
          {/*<CustomCancelButton width={"125px"} onClick={onClose}>
            {actionType === "delete" ? "Cancel" : "Close"}
            {/* Cancel 
          </CustomCancelButton>
          */}
          <CustomCancelButton buttonText= {actionType === "delete" ? "Cancel" : "Close"} width={"125px"} onClick={onClose}/>
        </DialogActions>
        {/* </div> */}
      </Dialog>
    </>
  );
};

export default NodeActionDialog;
